import { createSlice } from "@reduxjs/toolkit";

export const adaptabilitySlice = createSlice({
    name: 'adaptability',
    initialState: {
        page: 1,
        completed: false,
        score: 0,
        maxScore:0,
        questions:[
            {
                answer:'',
                score:0,
                max:0
            },
            {
                answer:'',
                score:0,
                max:0
            },
            {
                answer:'',
                score:0,
                max:0
            }
        ]
    },
    reducers: {
        nextPage: state => {
            state.page += 1
        },
        resetPage: state => {
            state.page = 1
        },
        previousPage: state => {
            state.page -= 1
        },
        questionAnswered: (state, action) =>{
            const {question, answer, score, max } = action.payload;
            state.questions[question].answer = answer
            state.questions[question].score = score
            state.questions[question].max = max
            const emptyQuestion = state.questions.find(question => question.answer === '')
            if(!emptyQuestion) state.completed = true
        },
        restart: state => {}
    }
})

export const {nextPage, previousPage, questionAnswered, resetPage, restart} = adaptabilitySlice.actions
export const selectPage = state => state.adaptability.page
export const selectAdaptabilityQuestions = state => state.adaptability.questions
export const selectAdaptabilityComplete = state => state.adaptability.completed
export default adaptabilitySlice.reducer